import React from 'react';
import { Table } from 'antd';
import 'antd/dist/reset.css';

const OwnerPage = () => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'ID Card',
      dataIndex: 'back_image',
      key: 'back_image',
    },
  
    {
      title: 'Selfie',
      dataIndex: 'front_image',
      key: 'front_image',
    },
    {
      title: 'Address',
      dataIndex: 'permanent_address',
      key: 'permanent_address',
    },
    {
      title: 'Email',
      dataIndex: 'email_address',
      key: 'email_address',
    },
    {
      title: 'Action',
      dataIndex: 'verified',
      key: 'action',
      render: (verified, record) => (
        <button onClick={() => handleAction(record)}>
          {verified ? 'Delete' : 'Verify'}
        </button>
      ),
    },
  ];

  const [dataSource, setDataSource] = React.useState([]);

  const handleAction = (record) => {
    if (record.verified) {
      // Handle delete action
      console.log('Delete user:', record.id);
    } else {
      // Handle verify action
      console.log('Verify user:', record.id);
    }
  };

  React.useEffect(() => {
    fetch('https://main-matrixai-server-lujmidrakh.cn-hangzhou.fcapp.run/api/admin/fetchUserInfoAdmin', { 
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setDataSource(data.map(item => ({ ...item, key: item.id })));
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
  }, []);

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ marginBottom: '16px' }}>Owner Management</h1>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
        scroll={{ y: 240 }}
        style={{
          backgroundColor: '#e6f7ff', // Light blue background for the table
        }}
       
      />
    </div>
  );
};

export default OwnerPage;
